export const SPACE_BETWEEN_ITEMS_DESKTOP = 16;
export const SPACE_BETWEEN_ITEMS_MOBILE = 8;
export const ITEMS_TO_SCROLL_DESKTOP = 4;
export const ITEMS_TO_SCROLL_MOBILE = 1;
export const TAB_ITEMS_MIN_LENGTH = 2;
